export default "__VITE_ASSET__e5865f86__"